export default __webpack_public_path__ + "static/media/shuttle_map.cbb67a11.svg";